var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIesgarantznak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "143.935mm",
    height: "144.224mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1127 1130",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004874",
    d: "M198 708c31,38 102,123 153,162 42,41 147,118 181,139l31 -15c-11,6 -22,12 -33,17 -97,27 -220,81 -311,-1 -91,-82 -50,-203 -21,-302zm-86 -184c-57,-93 -49,-203 -19,-265 103,-218 449,-16 592,113 14,12 18,21 34,34l-55 53 206 8 28 -206 -53 40c-30,-41 -73,-79 -117,-111 108,-19 250,-60 306,72 46,107 -6,228 -54,323 -77,156 -257,323 -417,409 -88,-41 -300,-213 -354,-309l-11 23 16 -31c34,-87 92,-156 151,-226l65 43 -45 -205 -207 26 54 43c-18,30 -76,80 -114,157l-6 9zm470 -427c-10,-5 -15,-9 -16,-9 3,1 8,5 16,9zm-16 -9c-49,-10 -330,-174 -499,-27 -98,86 -70,264 -25,377 14,34 40,83 53,111 -17,30 -39,84 -51,116 -17,44 -28,82 -36,128 -40,226 71,368 310,326 55,-10 193,-56 234,-92 28,16 355,197 510,36 65,-67 69,-175 56,-264 -15,-103 -57,-163 -91,-254 29,-64 187,-338 35,-476 -155,-142 -368,-28 -496,19zm355 618c34,76 31,107 41,159 1,227 -202,202 -360,148l-13 -5 -37 19 49 -25c104,-80 247,-181 314,-287l42 -64 -36 55z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIesgarantznak);
export default __webpack_public_path__ + "static/media/iesgarantznak.4fb7c989.svg";
export { ForwardRef as ReactComponent };